import namespace from '../../config/Namespace';

const types = {
  actions: {
    resetList: 'resetList',
    setColumns: 'setColumns',
    setColumnVisibility: 'setColumnVisibility',
    setFilters: 'setFilters',
    fetchCashIn: 'fetchCashIn',
    fetchCashInSuccess: 'fetchCashInSuccess',
    fetchCashInFailure: 'fetchCashInFailure',
    fetchCashOut: 'fetchCashOut',
    fetchCashOutSuccess: 'fetchCashOutSuccess',
    fetchCashOutFailure: 'fetchCashOutFailure',
    fetchTransaction: 'fetchTransaction',
    fetchTransactionSuccess: 'fetchTransactionSuccess',
    fetchRefund: 'fetchRefund',
    fetchChargeback: 'fetchChargeback',
    fetchRefundDetailsSuccess: 'fetchRefundDetailsSuccess',
    fetchBalanceReport: 'fetchBalanceReport',
    fetchBalanceWalletReport: 'fetchBalanceWalletReport',
    // Transaction Details
    fetchTransactionDetails: 'fetchTransactionDetails',
    fetchTransactionDetailsSuccess: 'fetchTransactionDetailsSuccess',
    fetchTransactionDetailsFailure: 'fetchTransactionDetailsFailure',
    fetchExtraInfo: 'fetchExtraInfo',
    fetchExtraInfoSuccess: 'fetchExtraInfoSuccess',
    fetchExtraInfoLoading: 'fetchExtraInfoLoading',
    // Transaction Details History
    fetchTransactionHistoryLoading: 'fetchTransactionHistoryLoading',
    fetchTransactionHistory: 'fetchTransactionHistory',
    fetchTransactionHistorySuccess: 'fetchTransactionHistorySuccess',
    fetchTransactionHistoryFailure: 'fetchTransactionHistoryFailure',
    // Transaction History Details
    fetchLogDetailsLoading: 'fetchLogDetailsLoading',
    fetchLogDetails: 'fetchLogDetails',
    fetchLogDetailsSuccess: 'fetchLogDetailsSuccess',
    fetchLogDetailsFailure: 'fetchLogDetailsFailure',
    // filters
    fetchTransactionsFiltersSuccess: 'fetchTransactionsFiltersSuccess',
    fetchTransactionsFilters: 'fetchTransactionsFilters',
    fetchInstallmentsReleases: 'fetchInstallmentsReleases',
    fetchInstallmentsReleasesSuccess: 'fetchInstallmentsReleasesSuccess',
  },
};

export default namespace('transaction', types);
